export const RECEIVE_ACTIONS = 'RECEIVE_ACTIONS';
export const REQUEST_ACTIONS = 'REQUEST_ACTIONS';